/**
 * Legacy strings for the three training-content screens —
 * Admin/CategoriesManagement, Admin/EditQuestions (+ Admin/Qusetions for the
 * shared column headers) and Admin/CertificateSettings.
 */
export const categoriesStrings = {
  actionFailed: 'تعذر إتمام العملية',
  fail: {
    save: 'تعذر حفظ الموضوع',
  },
  imported: 'تم استيراد الموضوع بنجاح',
  deleteFailed: 'تعذر إتمام العملية',
  title: 'إدارة المواضيع', // CategoriesManagement.PanelHeading
  subtitle: 'إضافة أو تعديل موضوع', // PanelSubHeading

  actions: {
    create: 'موضوع جديد', // btnNew
    upload: 'إضافة موضوع من ملف', // btnCategoryUpload
  },

  filter: {
    publicity: 'التخصيص', // Publicity
    all: 'الكل', // All
    public: 'عام', // Public
    private: 'خاص', // Private
  },

  stats: {
    caption: 'ملخص المواضيع',
    total: 'إجمالي المواضيع',
    chapters: 'إجمالي المقاطع',
    questions: 'إجمالي الأسئلة',
    minutes: 'دقائق المحتوى',
  },

  columns: {
    index: 'م', // TableHead_1
    name: 'الاسم بالعربية', // TableHead_2
    arabicLength: 'مدة المادة العربية بالدقائق', // spanChapterLengthAr — icon-only header
    nameEn: 'الاسم بالإنجليزية', // TableHead_4
    englishLength: 'مدة المادة الإنجليزية بالدقائق', // spanChapterLengthEn — icon-only header
    chapters: 'عدد المقاطع', // TableHead_5 — icon-only header
    questions: 'عدد الأسئلة', // ManageExams.LocQuestionsCount
    createdOn: 'تاريخ الإنشاء', // TableHead_7
    publicity: 'التخصيص', // Publicity
  },

  row: {
    edit: 'تعديل', // btnEdit
    chapterFiles: 'الملفات المرئية', // CategoriesManagement.ChapterFiles
    delete: 'حذف المقطع', // btnDelete
    exportTopic: 'تصدير الموضوع كملف مضغوط', // BtnExportCategoryZip
    exportQuestions: 'تصدير الأسئلة إلى Excel', // CatagoriesExportExcelResource1
  },

  /** الملفات المرئية — the legacy's chapter player, `#videoModal`. */
  chapterFiles: {
    title: 'الملفات المرئية',
    language: 'لغة المقطع',
    arabic: 'العربية',
    english: 'الإنجليزية',
    loading: 'جار التحميل…',
    empty: 'لا توجد مقاطع في هذا الموضوع',
    missing: 'لم يتم رفع مقطع بهذه اللغة',
    missingShort: 'غير متوفر',
  },

  /* The two exports answer EITHER a file or a refusal as JSON — see `exportCategory`. A
     saved file says its own name, because the browser puts it somewhere the page cannot. */
  exported: (filename) => `تم تحميل الملف: ${filename}`,

  /** The موضوع جديد form — Views/CategoriesManagement `#category_edit_modal`. */
  form: {
    /* The page title when EDITING; creating uses `actions.create`. Both were read by the
       screen and never defined — the edit page opened with a blank heading, and a
       successful save with an empty toast. */
    editTitle: 'تعديل الموضوع',
    saved: 'تمت العملية بنجاح',

    /* Section headings. The legacy's were the two LANGUAGES, one per column;
       the columns now hold a name and its translation on one line, so the
       headings name what the section is FOR instead. */
    naming: 'اسم الموضوع ووصفه',
    presentation: 'الظهور والصورة',
    nameAr: 'الاسم بالعربي',
    descriptionAr: 'الوصف بالعربي',
    nameEn: 'الاسم بالإنجليزي',
    descriptionEn: 'الوصف بالإنجليزي',
    publicity: 'التخصيص',
    public: 'عام', // CategoriesManagement.Public
    private: 'خاص', // CategoriesManagement.Private
    banner: 'رفع صورة',
    save: 'حفظ',
    required: 'الحقل مطلوب',
  },

  uploadHint: 'الملف يجب أن يكون من نوع Zip !', // UploadFileRegex.Text
  deleteConfirm: 'هل تريد حذف هذا الموضوع؟',
  deleted: 'تمت العملية بنجاح', // Operation_Completed_Successfully
  close: 'إغلاق',
}

/** The three steps the legacy's own category wizard uses. */
export const categoryWizard = {
  steps: {
    topic: 'بيانات الموضوع', // _ManageCategoryModal step 1
    chapters: 'المقاطع المرئية', // step 2
    questions: 'الأسئلة', // step 3
  },
  chapters: {
    title: 'مقاطع الموضوع',
    add: 'إضافة مقطع',
    titleAr: 'عنوان المقطع بالعربية', // Groups.lblArabicResource1_Text
    titleEn: 'عنوان المقطع بالإنجليزية', // Groups.lblEnglishResource1_Text
    videoAr: 'المقطع بالعربية (mp4)',
    videoEn: 'المقطع بالإنجليزية (mp4)',
    empty: 'لم تتم إضافة مقاطع بعد',
    remove: 'حذف المقطع',
    duration: 'المدة',
    reset: 'إفراغ الحقول',
  },
  questions: {
    title: 'أسئلة الموضوع',
    add: 'إضافة سؤال',
    fromExcel: 'استيراد من ملف إكسل',
    empty: 'لا توجد أسئلة لهذا الموضوع',
    count: 'سؤالا',
  },
}

export const questionsStrings = {
  title: 'قائمة الأسئلة', // EditQuestions.PageResource1.Title
  /* Read by the screen and never defined — every one of these was an empty toast. */
  deleteFailed: 'تعذر إتمام العملية',
  saved: 'تمت العملية بنجاح', // Resources.Operation_Completed_Successfully
  imported: 'تم استيراد الأسئلة بنجاح',

  actions: {
    create: 'إضافة سؤال', // EditQuestions.AddQuestion.Text
    excel: 'رفع ملف الأسئلة', // Resources.Questions_Excel_Upload
  },

  /* THE WHOLE BANK GOES DOWN AND COMES BACK, which is what the legacy does: the file is
     every question with its id, not a blank template, so a row that keeps its id is an
     edit and a row added with no id is a new question. The wording says so — "download,
     change, upload" — because "download the template" describes a different transaction. */
  excel: {
    notes:
      'يرجى تنزيل ملف الأسئلة أولاً بصيغة إكسل، ثم إجراء التحديثات اللازمة عليه، وبعد ذلك قم بتحميله للحفظ',
    template: 'تحميل القالب',
  },

  columns: {
    index: 'م', // TableHead_ID
    text: 'السؤال', // TableHead_Question
    answer: 'الإجابة المقبولة', // Qusetions.Questions_HeaderText3
    option1: 'إجابة 1', // Questions_HeaderText4
    option2: 'إجابة 2', // Questions_HeaderText5
    option3: 'إجابة 3', // Questions_HeaderText6
    option4: 'إجابة 4', // Questions_HeaderText7
    category: 'الموضوع', // Qusetions.Subject
    difficulty: 'المستوى', // Questions_HeaderText9
  },

  row: {
    edit: 'تعديل', // ManageExams.btnEdit
    delete: 'حذف', // ManageExams.btnDelete
  },

  form: {
    optionsPanel: 'خصائص السؤال و الإجابة', // OptionsPanelTitle
    editTitle: 'تعديل سؤال',
    /* Section headings. `optionsPanel` stays where it is — it is the sheet's
       subtitle — so the section above the four boxes needs its own name rather
       than repeating the line already at the top of the sheet. */
    options: 'الخيارات',
    /* The legacy asks for the whole question TWICE — Views/EditQuestions
       `txtArabicQ`/`txtEnglishQ` and four options each — plus an image per
       language. Only the Arabic half was here. */
    questionAr: 'نص السؤال بالعربية', // EditQuestions.QuestionTitle
    questionEn: 'نص السؤال بالإنجليزية',
    optionsAr: 'الخيارات بالعربية',
    optionsEn: 'الخيارات بالإنجليزية',
    imageAr: 'صورة السؤال بالعربية', // fULDArabicQuestionImage
    imageEn: 'صورة السؤال بالإنجليزية', // fULDEnglishQuestionImage
    classification: 'التصنيف والإجابة',
    chosenAnswer: 'الإجابة المختارة', // ChosenAnswer
    difficulty: 'مستوى الصعوبة', // DifficultyLevel
    category: 'ينتمي لهذا التصنيف', // ParantCategory
    question: 'السؤال', // QuestionTitle
    required: 'الحقل مطلوب',
    save: 'حفظ',
  },

  deleteConfirm: 'هل تريد حذف هذا السؤال؟',

  deleted: 'تمت العملية بنجاح', // Operation_Completed_Successfully
  close: 'إغلاق',
}

export const certificatesStrings = {
  title: 'إدارة الشهادات', // CertificateSettings.PageResource1.Title
  /* Outcome wording. These three were READ by the screen and never defined, so a failed
     save showed an empty toast and the clone confirmation was a dialog with no question
     in it. */
  actionFailed: 'تعذر إتمام العملية',
  fail: {
    list: 'تعذر تحميل الشهادات',
    save: 'تعذر حفظ الشهادة',
    layout: 'تعذر حفظ تصميم الشهادة',
    copy: 'تعذر نسخ الشهادة',
    delete: 'تعذر حذف الشهادة',
  },
  saved: 'تمت العملية بنجاح', // Resources.Operation_Completed_Successfully
  cloneTitle: 'نسخ النموذج',
  cloneConfirm: 'هل تريد إنشاء نسخة من هذا النموذج؟',
  subtitle: 'إضافة أو تعديل أو حذف لنماذج الشهادات', // PanelSubHeading

  actions: {
    create: 'نموذج جديد', // btnNew
  },

  columns: {
    index: 'م', // TableHead_1
    name: 'الاسم بالعربية', // Groups.lblArabicResource1.Text
    nameEn: 'الاسم بالإنجليزية', // Groups.lblEnglishResource1.Text
    uploadedOn: 'تاريخ الرفع', // TableHead_3
  },

  row: {
    arabicTemplate: 'نموذج اللغة العربية', // arabicTemplateImgCaption
    englishTemplate: 'نموذج اللغة الإنجليزية', // englishTemplateImgCaption
    edit: 'تعديل', // btnEdit
    clone: 'نسخ', // ProgramsManagement.Clone
    delete: 'حذف', // btnDelete
  },

  /**
   * The نموذج جديد form — Views/CertificateSettings/Index.cshtml `#edit_modal`.
   * Three text fields beside the two artwork uploads, exactly as the legacy
   * lays them out.
   */
  form: {
    info: 'معلومات نموذج الشهادة', // CertificateSettings, left column heading
    files: 'ملفات النماذج', // right column heading
    nameAr: 'الاسم بالعربية', // Groups.lblArabicResource1.Text
    nameEn: 'الاسم بالإنجليزية', // Groups.lblEnglishResource1.Text
    prefix: 'بادئة الترميز', // IdentifierPrefixTitle
    prefixPlaceholder: 'نص البادئة', // IdentifierPrefixText
    prefixHint: 'اختياري — يسبق رقم الشهادة',
    fileAr: 'رفع نموذج اللغة العربية', // TemplateFileAr
    fileEn: 'رفع نموذج اللغة الإنجليزية', // TemplateFileEn
    fileSpec: 'PNG 1528x1080', // the legacy tooltip on both upload wrappers
    save: 'حفظ', // BtnSave
    required: 'الحقل مطلوب', // Users.RequiredFieldValidator
    lengthError: 'لابد ألا يقل النص عن 2 أحرف و لا يزيد عن 300 حرف', // ArabicOnlyRegex.Text
    prefixError: 'يرجى التأكد من أن البادئة تتراوح بين 1 و 100 حرف', // MessagePrefixError
  },

  /**
   * The layout editor — the legacy's Fabric.js canvas
   * (Views/CertificateSettings/js.cshtml, `#drawingScreen`). Four text layers
   * are placed over the artwork: the holder's name, the programme, the date and
   * the verification code.
   */
  /**
   * The layout editor — the legacy's Fabric.js canvas
   * (Views/CertificateSettings/js.cshtml, `#drawingScreen`). Four text layers
   * are placed over the artwork: the holder's name, the programme, the date and
   * the verification code.
   */
  editor: {
    title: 'نموذج الشهادة',
    layers: 'عناصر الشهادة',
    properties: 'الخصائص',
    artwork: 'خلفية الشهادة',
    name: 'اسم المتدرب', // General.LearningProgramGeneralInfoReport.UserName
    program: 'البرنامج التدريبي', // Resources.LearningProgram
    date: 'التاريخ', // Resources.Timestamp
    code: 'رمز التحقق', // CertificateValidation
    font: 'نوع الخط', // Toolbox.Font.Caption
    color: 'لون الخط', // Toolbox.Color.Caption
    size: 'حجم الخط', // Toolbox.Size.Caption
    style: 'تنسيق الخط', // Toolbox.Style.Caption
    bold: 'عريض', // Toolbox.Style.Bold
    italic: 'مائل', // Toolbox.Style.Italic
    center: 'توسيط أفقي', // Toolbox.Position.HorizontalCenter
    offset: 'إزاحة', // CertificateSettings.CenterOffset
    offsetHint: 'إزاحة أفقية عن منتصف الشهادة بالبكسل.', // CenterOffsetTooltip
    align: 'محاذاة النص',
    alignStart: 'يمين',
    alignCenter: 'وسط',
    alignEnd: 'يسار',
    show: 'إظهار العنصر',
    hide: 'إخفاء العنصر',
    editText: 'انقر مرتين لتعديل النص',
    /* The legacy seeds each layer with its own instruction rather than a specimen —
       `setCanvas` picks these by UI language — so the one thing you must discover about
       this screen is written on the thing you must discover it about. */
    seed: {
      name: 'انقر مرتين لتعديل الاسم',
      program: 'انقر مرتين لتعديل البرنامج',
      date: 'انقر مرتين لتعديل التاريخ',
      code: 'انقر مرتين لتعديل معرف الشهادة',
    },
    zoomIn: 'تكبير',
    zoomOut: 'تصغير',
    zoomFit: 'ملء الشاشة',
    undo: 'تراجع',
    redo: 'إعادة',
    reset: 'إعادة تعيين',
    close: 'إغلاق', // CertificateSettings.btnClose
    saved: 'تمت العملية بنجاح', // Operation_Completed_Successfully
    position: 'الموضع',
    uploadArtwork: 'اختيار صورة الخلفية',
    noArtwork: 'لم يتم رفع صورة بعد',
  },

  deleteConfirm: 'هل تريد حذف هذا النموذج؟',

  deleted: 'تمت العملية بنجاح', // Operation_Completed_Successfully
  close: 'إغلاق',
}
